export default __webpack_public_path__ + "static/media/startLogo.89e32f52.png";